module.exports = __webpack_public_path__ + "static/img/p2-2.db7f79d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/p2-2.png
// module id = IvW6
// module chunks = 0